module.exports = __webpack_public_path__ + "static/media/costStructure.a02c403e.svg";